<template>
	<span class="fi-message">
		<template v-for="s in spans">
			<span v-if="s.type === 'text'">{{ s.text }}</span>
			<sym-icon v-else-if="s.type === 'icon'" :name="s.text"></sym-icon>
			<it-link v-else-if="s.type === 'link' && fi.customURL" :to="fi.customURL">{{ ln }}</it-link>
			<object-link v-if="s.type === 'object' && fi.srcId > 0" :src-id="fi.srcId" :src-type="fi.srcType">{{ fi.srcName }}</object-link>
		</template>
	</span>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";
import ItLink from "@/router/ItLink.vue";
import {ForceInfo} from "@t/processes/ForceInfo.ts";
import ObjectLink from "@fd/helpers/ObjectLink.vue";
import SymIcon from "@fd/helpers/SymIcon.vue";

const props = defineProps<{
	fi: ForceInfo,
	responsible: string,
	enteredBy: string
}>();
const LINK = "[[[link]]]";
interface SpanTx {
	type: "text" | "link" | "object" | "icon",
	text?: string;
}

const tx = computed<string>(() => {
	if (!!props.fi.text) return props.fi.text;
	return LINK;
});

const spans = computed<SpanTx[]>(() => {
	const sp:SpanTx[] = [];
	const t = tx.value;
	let pos = 0;
	while (pos < t.length) {
		const idx = t.indexOf("[[[", pos);
		if (idx < 0) {
			// only text
			sp.push({ type: "text", text: t.substring(pos) }); // rest of the text
			break;
		} else {
			const eidx = t.indexOf("]]]", idx + 3);
			if (eidx < 0) {
				// end of mark not found
				sp.push({ type: "text", text: t.substring(pos) }); // rest of the text
				break;
			} else {
				if (idx > pos) sp.push({ type: "text", text: t.substring(pos, idx) }); // prefix of mark
				const mark = t.substring(idx + 3, eidx);
				if (mark === 'link') sp.push({ type: "link" });
				else if (mark === 'object') sp.push({ type: "object" });
				else if (mark.startsWith("icon:")) sp.push({ type: "icon", text: mark.substring(5) });		// icon:case = icon with name case
				else sp.push({ type: "text", text: t.substring(idx, eidx + 3) });
				pos = eidx + 3;
			}
		}
	}
	return sp;
});

const ln = computed<string>(() => props.fi.customLinkName || props.fi.customURL);

function hasUnusedMark(mark: "link"|"object"): boolean {
	const isSpan = spans.value.findIndex((sp) => sp.type === mark) >= 0;
	if (!isSpan) {
		if (mark === "link") return !!props.fi.customURL;	// has custom URL but not emitted
		else if (mark === "object") return (!!props.fi.srcName && props.fi.srcType > 0 && props.fi.srcId > 0);	// has object referenced but not emitted
	}
	return false;
}

defineExpose({
	hasUnusedMark
});
</script>

<style>

</style>